import { DataLayer } from "@grandvisionhq/analytics";
const siteFeature = "store_locator";
const pushStoreFiltersEvent = (event) => {
  const { eventName, interactionType } = event;
  DataLayer.pushEvent({
    event: eventName,
    site_feature: siteFeature,
    interaction_type: interactionType
  });
};
const pushStoreFiltersModalCloseEvent = (event) => {
  const { eventName, interactionType, closeOption } = event;
  DataLayer.pushEvent({
    event: eventName,
    site_feature: siteFeature,
    interaction_type: interactionType,
    close_option: closeOption
  });
};
const pushStoreFiltersModalClickEvent = (event) => {
  const { eventName, interactionType, listOfSelectedFilters, availableStores } = event;
  DataLayer.pushEvent({
    event: eventName,
    site_feature: siteFeature,
    interaction_type: interactionType,
    filters_applied_options: listOfSelectedFilters,
    filters_applied_quantity: listOfSelectedFilters ? listOfSelectedFilters.length.toString() : "0",
    available_stores: availableStores ? availableStores.toString() : null
  });
};
export {
  pushStoreFiltersEvent,
  pushStoreFiltersModalClickEvent,
  pushStoreFiltersModalCloseEvent,
  siteFeature
};
//# sourceMappingURL=storeFilters.js.map
